let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5ujc")).then(() => parcelRequire('dAv2D'));